module.exports = __webpack_public_path__ + "static/media/temple.2f85dea6.jpg";